// extracted by mini-css-extract-plugin
export default {"tablePanel":"wwptZ7"};